export const AFFINE_DRAG_HANDLE_WIDGET = 'affine-drag-handle-widget';
export const AFFINE_ADD_BLOCK_WIDGET = 'affine-add-block-widget';
